/* Ott-common */
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function entitlements(backendAxiosInstance) {
  function getAccessToken(deviceID) {
    return backendAxiosInstance.post('/blim/entitlements/v2/token',
      { deviceId: deviceID },
      {
        authType: AuthType.SESSION_TOKEN_AND_ACCESS_TOKEN,
      });
  }

  return {
    getAccessToken,
  };
}
